// パソツク メガメニュー ホバー展開
(function(){
  function initHoverMenu(){
    var headerInner = document.querySelector('.header');
    if(!headerInner) return;
    var menuDetails = headerInner.querySelectorAll('header-menu > details, .header__inline-menu details');
    menuDetails.forEach(function(details){
      var parent = details.parentElement;
      var summary = details.querySelector('summary');
      if(!summary) return;
      var closeTimer;
      // ホバーで開く
      parent.addEventListener('mouseenter', function(){
        clearTimeout(closeTimer);
        details.setAttribute('open','');
        summary.setAttribute('aria-expanded','true');
      });
      // 離れたら少し待って閉じる
      parent.addEventListener('mouseleave', function(){
        closeTimer = setTimeout(function(){
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded','false');
        }, 150);
      });
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initHoverMenu);
  } else {
    initHoverMenu();
  }
})();